<template>
    <nav class="text-gray-50 bg-indigo-700 h-16 flex justify-between items-center gap-x-16 px-10 ">
        <div @click="route.push('/dashboard')" class="text-2xl font-bold transform hover:scale-105 duration-700 cursor-pointer"><Icon/></div>
        <div class="w-full flex gap-x-8 select-none">
            <div v-for="router in routers" :key="router" class="relative" :class="router.permission.includes(userRole) ? 'block' : 'hidden'">
                <button class="focus:ring-indigo-500 focus:ring-2 rounded-full" @click="menu = router.title" @blur="menu = ''" type="button">{{router.title}}</button>
                <transition name="slide">
                    <div v-if="menu === router.title" class="-left-full bg-gray-100 dark:bg-gray-800 border rounded-lg dark:border-gray-700 w-60 shadow-lg top-8 absolute py-4 px-2 z-10">
                        <span v-for="sub in router.subrouters" :key="sub" >
                            <div v-if="sub.permission.includes(userRole)" class="hover:bg-gray-200 dark:hover:bg-gray-900 rounded-lg py-2 px-2">
                                <router-link :to="sub.path" v-slot="{ navigate }">
                                    <span @click="navigate" class="w-full h-full">
                                        <p class="text-left dark:text-gray-50 text-gray-800">{{sub.name}}</p>
                                        <p class="text-left text-sm text-gray-600 dark:text-gray-400">{{sub.description}}</p>
                                    </span>
                                </router-link>
                            </div>
                        </span>
                    </div>
                </transition>
            </div>
        </div>
        <div class="relative w-auto ">
            <span class="flex flex-row flex-1 gap-x-4">
                <p class="text-sm self-center whitespace-nowrap">Olá, {{userName}}</p>
                <span class="relative">
                    <button @click="profile = !profile" @blur="profile = false" class="cursor-pointer flex">
                        <div class="bg-indigo-300 rounded-full w-12 h-12">
                            <img v-if="avatar" class="rounded-full " :src="avatar" alt="">
                            <span v-else class="h-full w-full flex"><p class="m-auto text-2xl">{{userName[0]}}{{userName.split(' ')[1][0]}}</p></span>
                        </div>
                    </button>

                    <transition name="slide">
                        <div v-if="profile" class="-left-1/2 bg-gray-100 text-gray-700 dark:text-gray-300 dark:bg-gray-800 border rounded-lg dark:border-gray-700 w-24 shadow-lg top-14 absolute py-2 z-10">
                            <button @click.stop="goToProfile()" class="dark:hover:bg-gray-900 hover:bg-gray-200 py-2 px-2 w-full">
                                <p class="text-center">Perfil</p>
                            </button>
                            <button @click.stop="setMode()" class="dark:hover:bg-gray-900 hover:bg-gray-200 py-2 px-2 w-full flex gap-x-2">
                                <p class="text-center inline">Modo</p>
                                <span v-if="mode === 'dark'" class="material-icons-outlined">
                                    dark_mode
                                </span>
                                <span v-else class="material-icons-outlined">
                                    light_mode
                                </span>
                            </button>
                            <button @click.stop="logout()" class="dark:hover:bg-gray-900 hover:bg-gray-200 py-2 px-2 w-full">
                                <p class="text-center">Sair</p>
                            </button>
                        </div>
                    </transition>
                </span>
            </span>
        </div>
    </nav>
</template>

<script>
import { ref } from '@vue/reactivity'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { onBeforeUnmount, onMounted } from '@vue/runtime-core'
import { displayNotification } from '../../mixins/notification.js'
import Icon from '../Design/Icon.vue'
export default {
    name: 'Navbar',
    components: {
        Icon
    },
    setup () {
        const store = useStore()

        const userRole = ref('')
        userRole.value = store.getters['auth/user'].role
        const userName = ref('')
        userName.value = store.getters['auth/user'].nome
        const avatar = ref('')
        avatar.value = store.getters['auth/user'].avatar
        const routers = ref([])
        const menu = ref('')
        const profile = ref(false)
        routers.value = [
            {
                title: 'Lojas',
                subrouters: [
                    { name: 'Ativas', description: 'Lista das lojas ativas', path: '/dashboard/lojas/ativas', permission: ['administrador', 'pesquisador'] },
                    { name: 'Adesão', description: 'Lista das lojas adesão', path: '/dashboard/lojas/adesao', permission: ['administrador', 'pesquisador'] },
                    { name: 'Nova', description: 'Criar uma nova loja manualmente', path: '/dashboard/lojas/nova', permission: ['administrador'] }
                ],
                permission: ['administrador', 'pesquisador']
            },
            {
                title: 'Produtos',
                subrouters: [
                    { name: 'Lista de Produtos', description: 'Mostrar todos os produtos', path: '/dashboard/produtos', permission: ['administrador', 'pesquisador'] },
                    { name: 'Novo', description: 'Criar um novo produto', path: '/dashboard/produtos/novo', permission: ['administrador'] }
                ],
                permission: ['administrador', 'pesquisador']
            },
            {
                title: 'Pessoas',
                subrouters: [
                    { name: 'Usuários', description: 'Mostrar todos os usuários', path: '/dashboard/usuarios', permission: ['administrador'] },
                    { name: 'Cadastro', description: 'Cadastrar um novo usuário', path: '/dashboard/usuarios/novo', permission: ['administrador'] }
                ],
                permission: ['administrador']
            },
            {
                title: 'Métricas',
                subrouters: [
                    { name: 'Recolhas', description: 'Realizar a exportação dos dados de recolha', path: '/dashboard/exportar/recolhas', permission: ['administrador'] },
                    { name: 'Importação', description: 'Consultar os resultados das importações de novas lojas de adesão', path: '/dashboard/resultados/importacao', permission: ['administrador'] },
                    { name: 'Lojas Ativas', description: 'Realizar a exportação dos dados das lojas ativas', path: '/dashboard/exportar/ativas', permission: ['administrador'] }
                ],
                permission: ['administrador']
            }
        ]

        const route = useRouter()

        const mode = ref('')
        const getMode = () => {
            mode.value = localStorage.getItem('theme')
        }
        const setMode = () => {
            if (!localStorage.hasOwnProperty('theme')) {
                localStorage.setItem('theme', 'light')
            }
            const m = mode.value = localStorage.getItem('theme')
            if (m === 'dark') { localStorage.setItem('theme', 'light') } else if (m === 'light') { localStorage.setItem('theme', 'dark') }

            route.go(0)
        }

        onMounted(() => {
            getMode()
            document.addEventListener('watchLocalStorage', () => {
                userRole.value = store.getters['auth/user'].role
                userName.value = store.getters['auth/user'].nome
                avatar.value = store.getters['auth/user'].avatar
            }, false)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('watchLocalStorage', null, false)
        })

        const logout = async () => {
            await store.dispatch('auth/logout').then(r => {
                displayNotification(r)
                route.push('/').catch(() => {})
            }).catch(e => {
                displayNotification(e.response)
            })
        }
        const goToProfile = () => {
            route.push({ name: 'Profile', params: { id: store.getters['auth/user'].id } })
        }
        return {
            routers,
            menu,
            profile,
            userRole,
            userName,
            avatar,
            mode,
            route,
            goToProfile,
            setMode,
            logout
        }
    }

}
</script>

<style scoped>
.slide-enter-from {
  opacity: 0;
  transform: translateY(-10%);
}
.slide-enter-to {
  opacity: 1;
  transform: translateY(0%);
}

.slide-enter-active {
  transition: all 0.3s ease-in-out;
}

.slide-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-leave-from {
  opacity: 1;
  transform: translateY(0%);
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-10%);
}

</style>
